import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./style.css";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";

gsap.registerPlugin(ScrollTrigger);

const lenis = new Lenis({
  duration: 2,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
});

function raf(time) {
  lenis.raf(time);
  ScrollTrigger.update();
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

THREE.ColorManagement.enabled = false;
let model;

// Debug
// const gui = new dat.GUI()

// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();
// scene.background = new THREE.Color('#131419')

const textureLoader = new THREE.TextureLoader();
// const backgroundTexture = textureLoader.load('/images/bgTexture.png');

// Set background texture to the scene
// scene.background = backgroundTexture;

const loadingManager = new THREE.LoadingManager();
const progressBar = document.getElementById("progressBar");
const progressText = document.getElementById("progressText");

loadingManager.onProgress = (url, loaded, total) => {
  const progress = Math.round((loaded / total) * 100);
  progressText.textContent = `${progress}`;
};

const progressBarContainer = document.querySelector(".progressBarContainer");

loadingManager.onLoad = () => {
  gsap.to(progressBarContainer, {
    delay: 1,
    y: "-100%",
    duration: 1,
  });
};

const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath("/draco/");

const gltfLoader = new GLTFLoader(loadingManager);

gltfLoader.setDRACOLoader(dracoLoader);

let mixer = null;

const cursor = {x:0, y:0}
window.addEventListener("mousemove", (e)=>{

    cursor.x = e.clientX / (window.innerWidth) - 0.5;
    cursor.y = e.clientY / window.innerHeight - 0.5;
})

gltfLoader.load("/model/animChick/scene.gltf", (gltf) => {
  model = gltf.scene;
  model.position.set(0, -0.5, 0);
  model.scale.set(0.08, 0.08, 0.08);
  camera.position.set(1, 0.3, 0.5);
  model.rotation.set(0, 0.6, 0);
  camera.lookAt(model.position);

  mixer = new THREE.AnimationMixer(model);

  if (gltf.animations.length > 0) {
    gltf.animations.forEach((clip) => {
      mixer.clipAction(clip).play();
    });
  }
  scene.add(model);


  const animationChickenMove = ()=>{
    
    const cameraX = (cursor.x) - 1;
    const cameraY = - (cursor.y / 5);
    model.rotation.y = - cameraX;
    camera.position.y =  cameraY;
    window.requestAnimationFrame(animationChickenMove);
  }
  animationChickenMove()


  var responsiveModel = window.matchMedia("(max-width: 700px)")
  myFunction(responsiveModel) 
  responsiveModel.addListener(myFunction) 
  
  
  function myFunction(responsiveModel) {
  if (responsiveModel.matches) 
  {
    model.scale.set(0.045, 0.045, 0.045);
    model.position.set(0, -0.5, 0);

  }
}




});




const ambientLight = new THREE.AmbientLight(0xffffff, 1);
scene.add(ambientLight);

const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5);
scene.add(directionalLight);

// Punctual Light
const pointLight = new THREE.PointLight(0xffffff, 1);
pointLight.position.set(3, 3, 3); // Set the position of the light
scene.add(pointLight);

/* Sizes*/
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

// Base camera

const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.1,
  100
);

scene.add(camera);

// Controls
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;
controls.enableZoom = false;

/* Renderer */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  alpha: true,
});
renderer.outputColorSpace = THREE.LinearSRGBColorSpace;
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/*Animate*/
// const clock = new THREE.Clock()

const clock = new THREE.Clock();
let previousTime = 0;

const tick = () => {
  const elapsedTime = clock.getElapsedTime();
  const deltaTime = elapsedTime - previousTime;
  previousTime = elapsedTime;

  // Update the animation mixer
  if (mixer) {
    mixer.update(deltaTime);
  }

  controls.update();
  renderer.render(scene, camera);

  window.requestAnimationFrame(tick);
};

tick();

// const gridHelper = new THREE.GridHelper( 25, 25);
// scene.add( gridHelper );

gsap.to(".egg", {
  scrollTrigger: {
    trigger: ".secondSlideContainer",
    start: "-70% top",
    scrub: 0.2,
    // markers:true,
    end: "50% top",
    // pin:true,
    toggleActions: "restart pause resume pause",
  },
  x: "25vw",
  y: "-40vh",
  rotation: 270,
  duration: 1,
});

let currentScroll = 0;
let isScrollingDown = true;

let tween = gsap
  .to(".marquee__part", {
    xPercent: -100,
    repeat: -1,
    duration: 10,
    ease: "linear",
  })
  .totalProgress(0.5);

gsap.set(".marquee__inner", { xPercent: -50 });

window.addEventListener("scroll", function () {
  if (window.pageYOffset > currentScroll) {
    isScrollingDown = true;
  } else {
    isScrollingDown = false;
  }

  gsap.to(tween, {
    timeScale: isScrollingDown ? 1 : -1,
  });

  currentScroll = window.pageYOffset;
});


var responsiveGSAP = window.matchMedia("(max-width: 700px)")
myFunction(responsiveGSAP) 
responsiveGSAP.addListener(myFunction) 


function myFunction(responsiveGSAP) {
if (responsiveGSAP.matches) 
{
  var tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".fourthSlideContainer",
      start: "top top",
      end: "1000% top",
      scrub: 1,
      pin: true,
      // markers: true,
      toggleActions: "restart pause resume pause",
    },
  });
 
  tl.to(
    ".advantagesZoom",
    {
      scale:10,
      opacity: 0,
      rotation: -90,
      duration:2,
    },
    'changeColor'
  )
  tl.to(
    ".fourthSlideContainer",
    {
      background: "#A1875E",
      duration: 2,
    },
    'changeColor'
  )
  tl.to(
    ".cardsContainer",
    {
      scale:1,
      opacity:1,
      delay: -0.5,
      duration: 2,
    },
  )
  tl.to(
    ".card1",
    {
     x: "-100vw",
     delay: 6,
      // rotation: 30,
      duration: 6,
    },
  )
  tl.to(
    ".card2",
    {
      x: "100vw",
      // rotation: -30,
     delay: 6,
      duration: 6,
    },
  )
  tl.to(
    ".card3",
    {
      y: "-100vh",
      rotation: 30,
      delay: 6,
      duration: 6,
    },
  )
  tl.to(
    ".card4",
    {
      x: "-100vw",
      // rotation: 30,
      delay: 6,
      duration: 6,
    },
  )
  tl.to(
    ".card5",
    {
      x: "100vw",
       // rotation: 30,
       delay: 6,
       duration: 6,
    },
  )
  tl.to(
    ".card6",
    {
      y: "-100vh",
      rotation: -30,
      delay: 6,
      duration: 6,
    },
  )
  tl.to(
    ".card7",
    {
      x: "-100vw",
       // rotation: 30,
       delay: 6,
      duration: 6,
    },
  )
  tl.to(
    ".card8",
    {
      x: "100vw",
      // rotation: 30,
      delay: 6,
      duration: 6,
    },
  )

}
else
{
    var tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".fourthSlideContainer",
          start: "top top",
          end: "1000% top",
          scrub: 1,
          pin: true,
          // markers: true,
          toggleActions: "restart pause resume pause",
        },
      });

      tl.to(
        ".advantagesZoom",
        {
          scale:10,
          opacity: 0,
          duration:2,
        },
        'changeColor'
      )
      tl.to(
        ".fourthSlideContainer",
        {
          background: "#A1875E",
          duration: 2,
        },
        'changeColor'
      )
      tl.to(
        ".cardsContainer",
        {
          scale:1,
          opacity:1,
          delay: -0.5,
          duration: 2,
        },
      )
      tl.to(
        ".card1",
        {
          y: "-120vh",
          x:"30vw",
          delay:1,
          rotation: 30,
          duration: 4,
        },
      )
      tl.to(
        ".card2",
        {
          y: "-120vh",
          x:"-30vw",
          rotation: -30,
          duration: 4,
        },
      )
      tl.to(
        ".card3",
        {
          x:"30vw",
          y: "-120vh",
          rotation: 30,
          duration: 4,
        },
      )
      tl.to(
        ".card4",
        {
          x:"-30vw",
          y: "-120vh",
          rotation: -30,
          duration: 4,
        },
      )
      tl.to(
        ".card5",
        {
          x:"30vw",
          y: "-120vh",
          rotation: 30,
          duration: 4,
        },
      )
      tl.to(
        ".card6",
        {
          x:"-30vw",
          y: "-120vh",
          rotation: -30,
          duration: 4,
        },
      )
      tl.to(
        ".card7",
        {
          x:"30vw",
          y: "-120vh",
          rotation: 30,
          duration: 4,
        },
      )
      tl.to(
        ".card8",
        {
          x:"-30vw",
          y: "-120vh",
          rotation: -30,
          duration: 4,
        },
      )
   
      
}
}


// const cursorImage = document.createElement('img');
// cursorImage.src = 'paw.png'; // Replace 'your_image_url.jpg' with the URL of your image
// cursorImage.style.position = 'fixed';
// cursorImage.style.pointerEvents = 'none'; // Ensure the image doesn't interfere with mouse events
// cursorImage.style.width = '50px'; // Adjust width as needed
// cursorImage.style.height = 'auto'; // Maintain aspect ratio
// document.body.appendChild(cursorImage);

// const offsetX = cursorImage.width / 2;
// const offsetY = cursorImage.height / 2;

// document.addEventListener('mousemove', (event) => {
//     cursorImage.style.left = `${event.clientX - offsetX}px`;
//     cursorImage.style.top = `${event.clientY - offsetY}px`;
// });